// Traduções pt-PT embutidas para as chaves dos ecrãs de TV (tv.*).
//
// Fallback local quando o fetch remoto (/api/i18n/pt-pt.json) falha ou ainda
// não tem estas chaves — assim o toggle de idioma da landing TV funciona mesmo
// offline/standalone. Se o remoto tiver a chave, ele tem prioridade (ver
// I18nContext). Manter sincronizado com o seed 006_i18n_labels_seed.sql.
const ptPtFallbackLabels: Record<string, string> = {
  'tv.loadingCode': 'A carregar…',
  'tv.scanHint': 'Lê o código QR com o telemóvel para ligar este ecrã a um evento',
  'tv.manualHint': 'ou abre o karaokr no telemóvel e introduz o código acima',
  'tv.pairingFailed': 'Não foi possível gerar o código de pareamento. Tenta novamente na TV.',
  'tv.connectingStage': 'Pareamento aceite — a iniciar o Stage…',
  'tv.youtubeSignIn': 'Entra primeiro no YouTube',
  'tv.youtubeSignInHint':
    'O pop-up foi bloqueado. Abre accounts.google.com no browser desta TV, entra na tua conta Google (escolhe a opção QR/telemóvel para não teres de escrever com o telecomando) e volta aqui.',
  'tv.exitConfirm.title': 'Fechar a Karaokr TV?',
  'tv.exitConfirm.subtitle': 'O Stage vai parar neste ecrã.',
  'tv.exitConfirm.cancel': 'Continuar a ver',
  'tv.exitConfirm.close': 'Fechar app',
  'tv.menu.theme': 'Tema',
  'tv.menu.themeDark': 'Escuro',
  'tv.menu.themeLight': 'Claro',
  'tv.menu.language': 'Idioma',
  'tv.menu.langEn': 'English',
  'tv.menu.langPt': 'Português',

  // Duet invites (fallback local; o remoto tem prioridade)
  'duet.result.failed': 'Não foi possível convidar {name}. Tenta novamente.',

  // Consentimento implícito no join (fallback local; o remoto tem prioridade)
  'consent.implicitNoticeLead': 'Ao entrares ou adicionares músicas, concordas com os nossos',

  // Stage pré-live (fallback local; o remoto tem prioridade)
  'bigpicture.waitingHost': 'O evento começa em breve — escolhe as tuas músicas enquanto esperas!',

  // Avisos de vez (és o próximo / é agora)
  'turn.next.title': 'És o próximo!',
  'turn.next.hint': 'Aquece a voz — a tua música vem a seguir',
  'turn.on.title': 'É agora!',
  'turn.on.hint': 'Sobe ao palco!',

  // Folha de adicionar música (fallback local; o remoto tem prioridade)
  'search.artists': 'Artistas',
  'common.back': 'Voltar',

  // Códigos de entrada de sala (fallback local; o remoto tem prioridade)
  'room.entryCode': 'Código de entrada',
  'codeRedirect.notFoundHint': 'Este código não corresponde a nenhuma sala ativa. Confirma os 4 dígitos e tenta novamente.',
  'console.joinRoom.roomCodePlaceholder': 'ex.: 4821',
};

export function getPtPtFallbackLabel(key: string): string | undefined {
  return ptPtFallbackLabels[key];
}
